import {
  authResource
} from '@witkac/kartamiejska-resources';

import {
  notificationsMixin
} from './notifications';

/**
 *  Mixin do zarządzania dialogiem resetu hasła
 *  Zawiera pola
 *  - `passwordDialog` - czy pokazać modal dodawania / edycji
 *  - `passwordText` - tekst do wyświetlenia w dialogu
 *  - `resetEmail` - adres na który zostanie wysłany email
 *  Zawiera metody
 *  - `showPasswordDialog()` - otwiera okienko resetu hasła
 *  - `hidePasswordDialog()` - ukrywa okienko resetu hasła
 *  - `sendConfirmation()` - wysyła emaila z resetem hasła
 */
export const resetPasswordMixin = {
  mixins: [notificationsMixin],
  /**
   * Dane modułu
   *
   * @returns
   */
  data() {
    return {
      passwordDialog: false,
      passwordText: '',
      resetEmail: undefined
    };
  },
  methods: {
    /**
     * Otwiera okienko resetu hasła
     */
    showPasswordDialog() {
      this.passwordText = 'Na adres: ' + this.profile.email + ', zostanie wysłana wiadomość z linkiem do resetowania hasła.';
      this.resetEmail = this.profile.email;
      this.passwordDialog = true;
    },
    /**
     * Ukrywa okienko resetu hasła
     */
    hidePasswordDialog() {
      this.passwordDialog = false;
    },
    /**
     * Wysyła emaila z resetem hasła
     */
    sendConfirmation() {
      if (this.resetEmail) {
        authResource
          .resetPassword(this.resetEmail)
          .then(() => {
            this.notifySuccess('Wysłano wiadomość e-mail na podany adres.');
          })
          .catch(err => this.notifyError('Nie udało się wysłać wiadomości.', [err.graphQLErrors[0].message]));
      } else {
        this.notifyError('Nie pobrano adresu e-mail');
      }
    }
  }
};